/**
 * EVO — buyruq panelidagi BO'LIM buyruqlari.
 *
 * ╔══════════════════════════════════════════════════════════════════════════╗
 * ║ MUAMMO: Ctrl+K FAQAT HUJJAT TOPARDI, BO'LIM TOPMASDI                     ║
 * ║                                                                          ║
 * ║ Panel `SO-2026-00042` ni topadi — bu uning asosiy vazifasi va u yaxshi   ║
 * ║ ishlaydi. Lekin «kassa qayerda?» yoki «ABC tahlili qaysi bo'limda?»      ║
 * ║ degan savolga u HECH NARSA qaytarmasdi: server qidiruvi hujjatlar        ║
 * ║ ustidan yuradi, menyu esa mutlaqo boshqa ma'lumot.                       ║
 * ║                                                                          ║
 * ║ Natijada 12 guruh va ~90 banddan iborat yon menyuda odam sichqoncha      ║
 * ║ bilan guruhlarni ochib-yopib yurardi — kuniga o'nlab marta.              ║
 * ╚══════════════════════════════════════════════════════════════════════════╝
 *
 * ┌──────────────────────────────────────────────────────────────────────────┐
 * │ QIDIRUV SERVERGA CHIQMAYDI                                               │
 * │                                                                          │
 * │ Menyu — KLIYENTDAGI massiv (`config/menu.ts`). Uni serverdan so'rash     │
 * │ ma'nosiz bo'lardi: javob har doim bir xil va u allaqachon qo'lda.        │
 * │                                                                          │
 * │ Buning amaliy natijasi shu: bo'lim nomlari har harfda DARHOL             │
 * │ filtrlanadi, 300 ms debounce'siz. Hujjat qidiruvi esa avvalgidek         │
 * │ serverga boradi — ikkalasi bir oynada, lekin ikki tezlikda.              │
 * └──────────────────────────────────────────────────────────────────────────┘
 *
 * ┌──────────────────────────────────────────────────────────────────────────┐
 * │ RUXSAT — MENYUNING O'ZIDAN                                               │
 * │                                                                          │
 * │ Bu yerda birorta ruxsat tekshiruvi YOZILMAGAN va yozilmasligi kerak:     │
 * │ chaqiruvchi `filterMenu(MENU, can)` natijasini beradi, ya'ni ro'yxatga   │
 * │ ko'rish huquqi yo'q band UMUMAN kirmaydi.                                │
 * │                                                                          │
 * │ Ikkinchi tekshiruv qo'shish ikki xil haqiqat manbai yaratardi va         │
 * │ ular bir kun jimgina ajralib ketardi (`menu.ts` dagi 1-qoida).           │
 * └──────────────────────────────────────────────────────────────────────────┘
 */
import type { MenuGroup, MenuRoute } from '../config/menu';
import type { TranslationKey } from './i18n';

export interface NavCommand {
  /** `guruh:band` — ro'yxatda barqaror `key` sifatida ishlatiladi. */
  readonly id: string;
  readonly route: MenuRoute;
  /** Tarjima QILINGAN nom — solishtirish ham, ko'rsatish ham shu matn ustida. */
  readonly label: string;
  /** Guruh nomi: «Hisobotlar», «Moliya». Bir xil nomli bandlarni ajratadi. */
  readonly groupLabel: string;
}

/**
 * Solishtirishga tayyorlash.
 *
 * Apostrof variantlari (`'`, `’`, `‘`, `ʻ`) BIRLASHTIRILADI: o'zbek lotin
 * yozuvida `o'` / `o‘` / `oʻ` bir xil harf, lekin kod nuqtalari har xil.
 * Busiz «qoldiq» topilardi, «qoldig'i» esa yo'q — va foydalanuvchi
 * «ba'zan ishlaydi» degan xulosaga kelardi. Ayni qoida server tomonda ham
 * bor (`model-router.ts` dagi `normalize`).
 */
function normalize(text: string): string {
  return text
    .toLowerCase()
    .replace(/[’‘ʻʼ`´]/g, "'")
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Filtrlangan menyudan buyruqlar ro'yxatini quradi.
 *
 * `t` PARAMETR sifatida beriladi, modul ichidan chaqirilmaydi: shunda til
 * almashganda ro'yxat qayta quriladi va bu funksiya sof qoladi — testda
 * uni soxta tarjimon bilan chaqirsa bo'ladi.
 */
export function buildNavCommands(
  groups: readonly MenuGroup[],
  t: (key: TranslationKey) => string,
): readonly NavCommand[] {
  const out: NavCommand[] = [];

  for (const group of groups) {
    const groupLabel = t(group.labelKey);
    for (const item of group.items) {
      /*
       * `route === null` — ekran hali yozilmagan. `filterMenu` bunday
       * bandni allaqachon chiqarib tashlaydi, lekin tekshiruv shu yerda
       * ham turadi: u tipni toraytiradi (`MenuRoute | null` → `MenuRoute`)
       * va shu tufayli `<Link to={...}>` kastsiz ishlaydi.
       */
      if (item.route === null) continue;
      out.push({
        id: `${group.id}:${item.id}`,
        route: item.route,
        label: t(item.labelKey),
        groupLabel,
      });
    }
  }

  return out;
}

/** Bitta so'rovda ko'rsatiladigan eng ko'p bo'lim soni. */
export const NAV_COMMAND_LIMIT = 6;

/**
 * So'rovga mos bo'limlarni topadi va TARTIBLAYDI.
 *
 * ┌──────────────────────────────────────────────────────────────────────────┐
 * │ TARTIB MUHIM — «S» BOSGANDA «SAVDO» BIRINCHI BO'LISHI KERAK              │
 * │                                                                          │
 * │ Uch daraja bor va ular ANIQ ustunlik bilan:                              │
 * │   0 — nom AYNAN so'rovdan boshlanadi  («sav» → «Savdo buyurtmalari»)     │
 * │   1 — nom ichida uchraydi             («buyurtma» → «Sotuv buyurtmasi»)  │
 * │   2 — faqat GURUH nomida uchraydi     («moliya» → «Kassa hisoblari»)     │
 * │                                                                          │
 * │ Guruh mosligi eng pastda: «hisobot» deb yozgan odam avval nomida         │
 * │ «hisobot» bor bandlarni ko'rishi kerak, keyin butun «Hisobotlar»         │
 * │ guruhini — aks holda 24 ta hisobot bitta harfdan keyin ro'yxatni         │
 * │ to'ldirib, aniq mos bandni pastga itarib yuborardi.                      │
 * └──────────────────────────────────────────────────────────────────────────┘
 *
 * Bir xil darajadagilar orasida MENYUDAGI tartib saqlanadi (`sort` barqaror):
 * odam menyuni ko'rgan tartibda eslaydi va uni alifboga qayta terish
 * o'sha xotirani buzardi.
 */
export function matchNavCommands(
  commands: readonly NavCommand[],
  term: string,
  limit: number = NAV_COMMAND_LIMIT,
): readonly NavCommand[] {
  const needle = normalize(term);
  if (needle === '') return [];

  const ranked: { command: NavCommand; rank: number }[] = [];

  for (const command of commands) {
    const label = normalize(command.label);
    if (label.startsWith(needle)) {
      ranked.push({ command, rank: 0 });
      continue;
    }
    if (label.includes(needle)) {
      ranked.push({ command, rank: 1 });
      continue;
    }
    if (normalize(command.groupLabel).includes(needle)) {
      ranked.push({ command, rank: 2 });
    }
  }

  return ranked
    .sort((a, b) => a.rank - b.rank)
    .slice(0, limit)
    .map((entry) => entry.command);
}
